import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       component: resolve => require(['../pages/Content'], resolve),
//       children: [
//         {
//           path: '/seobigdata',
//           component: resolve => require(['../pages/SeoBigData'], resolve),
//         },  {
//           path: '/baidurank',
//           component: resolve => require(['../pages/BaiduRank'], resolve),
//         },  {
//           path: '/mousebaidurank',
//           component: resolve => require(['../pages/MouseBaiduRank'], resolve),
//         },  {
//           path: '/nofollow',
//           component: resolve => require(['../pages/NoFollow'], resolve),
//         },  {
//           path: '/badlink',
//           component: resolve => require(['../pages/BadLink'], resolve),
//         },  {
//           path: '/baidusite',
//           component: resolve => require(['../pages/BaiduSite'], resolve),
//         }, {
//           path: '/prohibitedwords',
//           component: resolve => require(['../pages/ProhibitedWords'], resolve),
//         },{
//           path: '/message',
//           component: resolve => require(['../pages/Message'], resolve),
//         }
//       ]
//     }, {
//       path: '/popup',
//       component: resolve => require(['../pages/PopUp'], resolve),
//     },
//     {
//       path: '/wyc',
//       component: resolve => require(['../pages/Wyc'], resolve),
//     },
//     {
//       path: '/difficulty',
//       component: resolve => require(['../pages/Difficulty'], resolve),
//     } , {
//       path: '/baiduwebsite',
//       component: resolve => require(['../pages/BaiduWebsite'], resolve),
//     },
//     {
//       path: '/showbox',
//       component: resolve => require(['../pages/ShowBoxVip'], resolve),
//     },
//     {
//       path: '/showboxmsg',
//       component: resolve => require(['../pages/ShowBoxError'], resolve),
//     },
//     {
//       path: '/showboxkeywords',
//       component: resolve => require(['../pages/ShowboxMsg'], resolve),
//     }
//   ]
// })

export default new Router({
  routes: [
    {
      path: "/",
      component: require("../pages/Content").default,
      children: [
        {
          path: "/seobigdata",
          component: require("../pages/SeoBigData").default
        },
        {
          path: "/outlink",
          component: require("../pages/OutLink").default
        },
        {
          path: "/baidurank",
          component: require("../pages/BaiduRank").default
        },
        {
          path: "/mousebaidurank",
          component: require("../pages/MouseBaiduRank").default
        },
        {
          path: "/nofollow",
          component: require("../pages/NoFollow").default
        },
        {
          path: "/badlink",
          component: require("../pages/BadLink").default
        },
        {
          path: "/baidusite",
          component: require("../pages/BaiduSite").default
        },
        {
          path: "/prohibitedwords",
          component: require("../pages/ProhibitedWords").default
        },
        {
          path: "/message",
          component: require("../pages/Message").default
        },
        {
          path: "/vedio",
          component: require("../pages/Vedio").default
        },
        {
          path: "/sofasniper",
          component: require("../pages/SofaSniper").default
        },
        {
          path: "/checkicp",
          component: require("../pages/CheckICP.vue").default
        }
      ]
    },
    {
      path: "/popup",
      component: require("../pages/PopUp").default
    },
    ,
    {
      path: "/pmpopup",
      component: require("../pages/PopUpPM").default
    },
    {
      path: "/wyc",
      component: require("../pages/Wyc").default
    },
    {
      path: "/difficulty",
      component: require("../pages/Difficulty").default
    },
    {
      path: "/baiduwebsite",
      component: require("../pages/BaiduWebsite").default
    },
    {
      path: "/showbox",
      component: require("../pages/ShowBoxVip").default
    },
    {
      path: "/showboxmsg",
      component: require("../pages/ShowBoxError").default
    },
    {
      path: "/showboxkeywords",
      component: require("../pages/ShowboxMsg").default
    },
    {
      path: "/checkicpinfo",
      component: require("../pages/CheckICPInfo.vue").default
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js